import Cookies from 'universal-cookie';

/**
 * Gets the visitor id of a user in the form
 * --
 * Note right now its not passed into the form, so we have to look at cookies
 */
export default function getVisitorId(_form) {
  return (new Cookies()).get('visitor_id') || '';
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/metadata/get_visitor_id.js